import React from "react"
import { Document, Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer"
import background_front from "./VorlageBriefpapier-1.png"
import QRCode from "qrcode"

const styles = StyleSheet.create({
  addressField: {
    fontSize: "12px",
    position: "relative",
    right: "19cm",
    top: "5.3cm",
  },
  page: {
    display: "flex",
    flexDirection: "row",
    backgroundColor: "#fff",
    width: "21cm",
    height: "29.7cm",
    orientation: "portrait",
    overflow: "hidden",
  },
  viewImage: {
    width: "21cm",
    height: "29.7cm",
    marginBottom: "-29cm",
    padding: 0,
    backgroundColor: "white",
    flexBasis: "100%",
    flexShrink: 0,
    flexGrow: 0,
  },
  image: {
    objectFit: "cover",
  },
  hint: {
    position: "relative",
    right: "23cm",
    maxWidth: "17.1cm",
    top: "8.2cm",
  },
  hintTitle: {
    textDecoration: "underline",
    fontSize: "10px",
  },
  hintText: {
    fontSize: "10px",
    textAlign: "justify",
  },
  hintAddress: {
    fontSize: "10px",
    paddingLeft: "0.2cm",
    marginLeft: "1.5cm",
    borderLeft: "1px solid black",
    marginTop: "0.2cm",
  },
  contentContainer: {
    position: "relative",
    right: "23cm",
    top: "12.5cm",
  },
  subject: {
    fontSize: "12px",
    textDecoration: "underline",
    marginBottom: "8px",
  },
  intro: {
    fontSize: "12px",
    marginBottom: "8px",
  },
  tableHeading: {
    fontSize: "12px",
    borderBottom: "1px solid black",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    marginBottom: "6px",
  },
  tableRow: {
    fontSize: "12px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  column1: {
    flexBasis: "60%",
    flexGrow: 0,
    flexShrink: 0,
  },
  column2: {
    flexBasis: "15%",
    flexGrow: 0,
    flexShrink: 0,
    textAlign: "right",
  },
  qrContainer: {
    width: "4cm",
    height: "4cm",
    padding: 0,
    flexBasis: "4cm",
    flexGrow: 0,
    flexShrink: 0,
    position: "relative",
    right: "9cm",
    top: "3cm",
  },
  dateContainer: {
    position: "relative",
    right: "9.3cm",
    top: "12.5cm",
  },
  date: {
    fontSize: "12px",
  },
})

const MyDocument = props => {
  const { number, articles, url } = props
  let canvas
  canvas = document.createElement("canvas")
  QRCode.toCanvas(canvas, url)
  const qr = canvas.toDataURL()
  const today = new Date().toLocaleDateString("de-DE", { timeZone: "Europe/Berlin" })
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.viewImage}>
          <Image src={background_front} style={styles.image} />
        </View>
        <View style={styles.addressField}>
          <Text>sleep.ink Versandzentrum</Text>
          <Text>Delphin-Werkstätten</Text>
          <Text>Pankstraße 8-10</Text>
          <Text>Eingang D</Text>
          <Text>13127 Berlin</Text>
        </View>
        <View style={styles.qrContainer}>
          <Image src={qr} style={styles.image} />
        </View>
        <View style={styles.dateContainer}>
          <Text style={styles.date}>{today}</Text>
        </View>
        <View style={styles.hint}>
          <Text style={styles.hintTitle}>Hinweise zur Geld-zurück-Garantie:</Text>
          <Text style={styles.hintText}>
            Legen Sie bitte Ihrer Rücksendung dieses Dokument bei, um eine Bearbeitung der
            Rückerstattung zu ermöglichen. Die Rückerstattung findet innerhalb weniger Tage statt,
            indem der Betrag Ihrer gewählten Zahlungsmethode gutgeschrieben wird. Bitte senden Sie
            die Ware an folgende Adresse:
          </Text>
          <View style={styles.hintAddress}>
            <Text>sleep.ink Versandzentrum</Text>
            <Text>Delphin-Werkstätten</Text>
            <Text>Pankstraße 8-10</Text>
            <Text>Eingang D</Text>
            <Text>13127 Berlin</Text>
          </View>
        </View>
        {articles.length > 0 && (
          <View style={styles.contentContainer}>
            <Text style={styles.subject}>{`Referenz: ${number}`}</Text>
            <Text style={styles.intro}>Sie senden uns folgende Artikel zurück:</Text>
            <View style={styles.tableHeading}>
              <Text style={styles.column1}>Artikel</Text>
              <Text style={styles.column2}>Menge</Text>
            </View>
            {articles.map(article => (
              <View key={article.sku} style={styles.tableRow}>
                <Text style={styles.column1}>{article.name}</Text>
                <Text style={styles.column2}>{article.returnQuantity}</Text>
              </View>
            ))}
          </View>
        )}
      </Page>
    </Document>
  )
}

export default MyDocument
